export default __webpack_public_path__ + "static/img-2-27743ab14218a65b917b2ddbe522ae6c.png";